import { initWidgetTheymes, openSupportWidget } from '../../supportTicket/supportWidgetTheymes';

type OpenSupportWidgetParams = {
    language?: string;
};

export class OpenSupportWidgetHandler {
    public async handle(params?: OpenSupportWidgetParams): Promise<void> {
        await initWidgetTheymes();

        openSupportWidget(params?.language);
    }
}
